import {
    BarcodeTypes,
    ComponentTypes,
    ITemplateBarcodeComponent,
    ITemplateComponent,
    ITemplateDateInputComponent,
    ITemplateMassGenerationComponent,
    ITemplateTableComponent,
    ITemplateProcureComponent,
    ITemplateYandexComponent,
    YandexListTypes,
    ITemplateSaveAndTicketComponent,
    ITemplateSaveToExistingTicketComponent,
    ITemplateTrackerIntegrationComponent,
    ITemplatePdfPasswordComponent,
    ITemplateHrPersonComponent,
    ITemplateCounterpartyComponent,
    ITemplateAutonumberComponent
} from "entities/template";
import { DEFAULT_AUTONUMBER_CODE, INITIAL_AUTONUMBER_MASK } from "./autonumber";
import { YandexWordFields } from "../const/yandex_word_fields";
import { LegalYandexWordFields } from "../const/legal_yandex_word_fields";
import { EmployeeWordFields } from "../const/employee_word_fields";
import { VendorFields } from "../const/vendor_fields";
import { getDefaultIprocStyles } from "./iproc_integration";

export const defaultComponentValue = (id: number, type: ComponentTypes) => {
    const component: ITemplateComponent = {
        type,
        id: id,
        label: "",
        required: [
            // в checkbox не нужен required
            ComponentTypes.dateInput,
            ComponentTypes.file,
            ComponentTypes.input,
            ComponentTypes.inputWithSelect,
            ComponentTypes.money,
            ComponentTypes.multiline,
            ComponentTypes.hrPerson,
            ComponentTypes.radio,
            ComponentTypes.select,
            ComponentTypes.table,
            ComponentTypes.yandex,
            ComponentTypes.legalYandex,
            ComponentTypes.counterparty,
            ComponentTypes.barcode
        ].includes(type)
    };

    if (type === ComponentTypes.yandex) {
        (component as ITemplateYandexComponent).optionsList = YandexListTypes.yaOrgs;
        (component as ITemplateYandexComponent).fieldsList = [YandexWordFields.ya_name];
    }

    if (type === ComponentTypes.legalYandex) {
        component.label = "Компания группы Яндекс";
        component.label_en = "Yandex group company";
        (component as ITemplateYandexComponent).optionsList = YandexListTypes.yaOrgs;
        (component as ITemplateYandexComponent).fieldsList = [LegalYandexWordFields.ya_name];
    }

    if (type === ComponentTypes.hrPerson) {
        (component as ITemplateHrPersonComponent).fieldsList = [EmployeeWordFields.hr_login];
    }

    if (type === ComponentTypes.counterparty) {
        (component as ITemplateCounterpartyComponent).fieldsList = [VendorFields.vendor];
    }

    if (type === ComponentTypes.barcode) {
        (component as ITemplateBarcodeComponent).barcodeType = BarcodeTypes.EAN_13;
        (component as ITemplateBarcodeComponent).ratio = "1.0";
    }

    if (type === ComponentTypes.autonumber) {
        (component as ITemplateAutonumberComponent).counterName = "";
        (component as ITemplateAutonumberComponent).name = "";
        (component as ITemplateAutonumberComponent).mask = INITIAL_AUTONUMBER_MASK;
        (component as ITemplateAutonumberComponent).code = DEFAULT_AUTONUMBER_CODE;
        (component as ITemplateAutonumberComponent).isAttrUsed = false;
    }

    if (type === ComponentTypes.massDocGeneration) {
        (component as ITemplateMassGenerationComponent).startrekQueue = "LEGALTEST";
    }

    if (type === ComponentTypes.saveAndTicket) {
        (component as ITemplateSaveAndTicketComponent).startrekQueue = "LEGALTEST";
        (component as ITemplateSaveAndTicketComponent).name = "xxcdoc_SaveAndTicket_file";
    }

    if (type === ComponentTypes.saveToExistingTicket) {
        (component as ITemplateSaveToExistingTicketComponent).startrekQueueAttach = "LEGALTEST";
        (component as ITemplateSaveToExistingTicketComponent).name = "startrekAttachDoc";
        (component as ITemplateSaveToExistingTicketComponent).label = "Номер тикета";
        (component as ITemplateSaveToExistingTicketComponent).label_en = "Ticket number";
    }

    if (type === ComponentTypes.trackerIntegration) {
        (component as ITemplateTrackerIntegrationComponent).name = "startrekIntegration";
    }

    if (type === ComponentTypes.iprocIntegration) {
        (component as ITemplateProcureComponent).list = getDefaultIprocStyles();
        (component as ITemplateProcureComponent).name = "iprocStyle";
        (component as ITemplateProcureComponent).startrekQueueIproc = "LEGALTEST";
        (component as ITemplateProcureComponent).hideIprocStyle = false;
        (component as ITemplateProcureComponent).isTemplate = true;
    }

    if (type === ComponentTypes.dateInput) {
        (component as ITemplateDateInputComponent).isDefaultDate = true;
    }

    if (type === ComponentTypes.pdfPassword) {
        (component as ITemplatePdfPasswordComponent).name = "pdfUserPassword";
    }

    if (type === ComponentTypes.table) {
        (component as ITemplateTableComponent).drawHeader = true;
    }

    return component;
};
